import qs from "qs";
import { apiVoissa, apiVoissaNoError, apiUrl } from "../../libs/api";

const URL_BASE = "/ephemeral-stories";

// Upload du fichier (multipart) - utilise apiUrl pour pouvoir gérer localement les erreurs (429/413/415)
// sans déclencher le toast global.
export const uploadStoryFile = (file, { cancelToken, onUploadProgress } = {}) => {
    const formData = new FormData();
    formData.append("file", file);
    return apiUrl.post(`${URL_BASE}/upload`, formData, {
        timeout: 3600000,
        cancelToken,
        onUploadProgress
    });
};

// Création de la story à partir d'un tmpId déjà uploadé
export const createStory = (data = {}, config = {}) => apiUrl.post(URL_BASE, data, config);

// Rings groupés par owner (cache backend 30 s)
export const fetchRings = (query = {}, config = {}) =>
    apiVoissa.get(`${URL_BASE}/rings?${qs.stringify(query)}`, config);

// Explorer (front, admin phase 1) : endpoint DÉDIÉ — stories "à la une" d'abord (ordre de modération)
// puis récence, périmètre `member` uniquement. Filtres gender/hot/contentRating comme Découvrir.
export const fetchExplorerRings = (query = {}, config = {}) =>
    apiVoissa.get(`${URL_BASE}/explorer?${qs.stringify(query)}`, config);

// Ring d'un user spécifique (utilisé par l'avatar de la page profil). NoError car le composant
// gère localement le 404 (= pas de story) sans toast global. Réponse : ring | null.
export const fetchUserStoryRing = (userId, config = {}) =>
    apiVoissaNoError.get(`${URL_BASE}/users/${userId}/ring`, config);

// Récupération d'une story unique (deep-link). NoError pour pouvoir surfacer le 404/403
// localement dans le composant sans déclencher de toast/redirect global.
export const fetchStory = (storyId, config = {}) =>
    apiVoissaNoError.get(`${URL_BASE}/${storyId}`, config);

// Marquer une story comme vue (idempotent). NoError car best-effort, on n'affiche rien.
export const markStoryViewed = (storyId, config = {}) =>
    apiVoissaNoError.post(`${URL_BASE}/${storyId}/views`, {}, config);

// Viewers (owner uniquement, paginé)
export const fetchStoryViewers = (storyId, query = {}, config = {}) =>
    apiVoissa.get(`${URL_BASE}/${storyId}/viewers?${qs.stringify(query)}`, config);

// Réactions de la story (owner/admin uniquement, paginé) — système de réactions générique
// (remplace l'ancien endpoint /likes supprimé côté back). Chaque item expose le réacteur via `owner`.
export const fetchStoryLikers = (storyId, query = {}, config = {}) =>
    apiVoissa.get(`${URL_BASE}/${storyId}/reactions?${qs.stringify(query)}`, config);

// Suppression (owner ou modérateur). Cascade serveur (vues + S3).
export const deleteStory = (storyId, config = {}) => apiVoissa.delete(`${URL_BASE}/${storyId}`, config);

// Helper : URL absolue du fichier media (les fileKey sont relatifs)
export const getStoryFileUrl = (fileKey = "") => {
    if (!fileKey) return "";
    const base = process.env.REACT_APP_BASE_STATIC || "";
    const sep = fileKey.startsWith("/") || base.endsWith("/") ? "" : "/";
    return `${base}${sep}${fileKey}`;
};

// Query keys (convention du repo - exportés en bas du fichier API)
export const EPHEMERAL_STORIES_KEY = "ephemeralStories";
export const EPHEMERAL_STORY_KEY = "ephemeralStory";
export const EPHEMERAL_STORY_RINGS_KEY = "ephemeralStoryRings";
// Rings "Découvrir" admin : toutes les stories actives (scope=all), clé de cache distincte.
export const EPHEMERAL_STORY_RINGS_ALL_KEY = "ephemeralStoryRingsAll";
// Rings "Explorer" admin (endpoint dédié /explorer : à la une d'abord puis récence, membre), clé distincte.
export const EPHEMERAL_STORY_RINGS_EXPLORER_KEY = "ephemeralStoryRingsExplorer";
export const EPHEMERAL_STORY_USER_RING_KEY = "ephemeralStoryUserRing";
export const EPHEMERAL_STORY_VIEWERS_KEY = "ephemeralStoryViewers";
export const EPHEMERAL_STORY_LIKERS_KEY = "ephemeralStoryLikers";
